(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_collections-navigation"] && !Shopify.designMode) return;
  try {
    (function() {
    const sections = document.querySelectorAll('.section-resource-list');
    sections.forEach(section => {
      const navigation = section.querySelector('.collections-navigation');
      if (!navigation) return;
      
      const radios = navigation.querySelectorAll('input[type="radio"]');
      const tabs = section.querySelectorAll('.collection-tab');
      
      radios.forEach(radio => {
        radio.addEventListener('change', () => {
          const collectionIndex = radio.dataset.collectionIndex;
          
          tabs.forEach(tab => {
            const isActive = tab.dataset.collectionIndex === collectionIndex;
            tab.classList.toggle('is-active', isActive);
          });
        });
      });
      
      // Set initial active state
      const checkedRadio = navigation.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        const initialIndex = checkedRadio.dataset.collectionIndex;
        tabs.forEach(tab => {
          tab.classList.toggle('is-active', tab.dataset.collectionIndex === initialIndex);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["linked-products"] && !Shopify.designMode) return;
  try {
    class LinkedProducts extends HTMLElement {
    constructor() {
      super();
      this.list = this.querySelector('[data-linked-products-list]');
      if (!this.list) return;
      this.filterBySize = this.hasAttribute('data-filter-by-size');
      this.init();
    }

    init() {
      if (this.filterBySize) {
        this.setupSizeFiltering();
      }
      if (this.hasAttribute('data-limit-mobile') || this.hasAttribute('data-limit-desktop')) {
        this.setupToggle();
      }
    }

    setupToggle() {
      const btn = this.querySelector('[data-toggle-btn]');
      if (!btn) return;
      const inner = this.querySelector('.linked-products__overflow-inner');

      btn.addEventListener('click', () => {
        const opening = !this.classList.contains('is-expanded');
        this.classList.toggle('is-expanded');
        btn.textContent = opening ? btn.dataset.labelFewer : btn.dataset.labelShow;

        if (!inner) return;

        if (opening) {
          inner.style.display = 'flex';
          inner.style.opacity = '0';
          inner.getBoundingClientRect();
          inner.style.opacity = '1';
        } else {
          inner.style.opacity = '0';
          inner.addEventListener('transitionend', () => {
            inner.style.display = 'none';
          }, { once: true });
        }
      });
    }

    setupSizeFiltering() {
      const initialSize = this.getSelectedSize();
      this.filterBySelectedSize(initialSize);

      document.addEventListener('change', (e) => {
        const input = e.target;
        if (!(input instanceof HTMLInputElement) && !(input instanceof HTMLSelectElement)) return;
        if (input.closest('quick-add-dialog') || input.closest('product-card')) return;

        const sizeOptionIndex = parseInt(this.getAttribute('data-size-option-index') || '0', 10);
        const sizeOptionName = this.getAttribute('data-size-option-name');

        const inSizeFieldset = !!input.closest(`[data-fieldset-index="${sizeOptionIndex}"]`);
        const isSizeSelect = input instanceof HTMLSelectElement && input.name === `options[${sizeOptionName}]`;

        if (!inSizeFieldset && !isSizeSelect) return;

        this.filterBySelectedSize(input.value);
      });
    }

    getSelectedSize() {
      const sizeOptionIndex = parseInt(this.getAttribute('data-size-option-index') || '0', 10);
      const sizeOptionName = this.getAttribute('data-size-option-name');

      const checkedInput = document.querySelector(
        `main variant-picker [data-fieldset-index="${sizeOptionIndex}"] input:checked`
      );
      if (checkedInput) return checkedInput.value;

      const select = document.querySelector(
        `main variant-picker select[name="options[${sizeOptionName}]"]`
      );
      return select ? select.value : null;
    }

    filterBySelectedSize(selectedSize) {
      const items = this.querySelectorAll('[data-linked-product-item]');

      items.forEach(item => {
        if (item.hasAttribute('data-active')) {
          item.classList.remove('linked-products__item--oos');
          return;
        }

        const sizeAvailability = item.getAttribute('data-size-availability');

        if (!sizeAvailability || !selectedSize) {
          item.classList.remove('linked-products__item--oos');
          return;
        }

        const pairs = sizeAvailability.split('|').map(pair => {
          const colonIdx = pair.lastIndexOf(':');
          return { size: pair.slice(0, colonIdx), available: pair.slice(colonIdx + 1) === 'true' };
        });

        const hasStock = pairs.some(({ size, available }) => size === selectedSize && available);
        item.classList.toggle('linked-products__item--oos', !hasStock);
      });
    }
  }

  customElements.define('linked-products', LinkedProducts);
  } catch(e) { console.error(e); }
})();

})();
